import moment from 'moment';

export const getAppointmentTimeLabel = (time) => {
  if (!time) return '';
  return time.includes(' - ') ? time.split(' - ')[0].trim() : time.trim();
};

export const buildAppointmentMoment = (reminderDate, time) => {
  if (!reminderDate) return null;
  const timeLabel = getAppointmentTimeLabel(time);
  if (timeLabel) {
    const dateOnly = moment(reminderDate).format('YYYY-MM-DD');
    const parsed = moment(`${dateOnly} ${timeLabel}`, 'YYYY-MM-DD hh:mm A', true);
    if (parsed.isValid()) {
      return parsed;
    }
  }
  return moment(reminderDate);
};

export const buildAppointmentStart = (reminderDate, time) => {
  const appointmentMoment = buildAppointmentMoment(reminderDate, time);
  return appointmentMoment ? appointmentMoment.toDate() : null;
};

export const formatAppointmentReminderBadge = (reminderNoteData) => {
  const appointmentMoment = buildAppointmentMoment(
    reminderNoteData?.reminderDate,
    reminderNoteData?.time
  );
  if (!appointmentMoment) return null;

  return {
    dateLabel: appointmentMoment.format('MMM DD, YYYY'),
    timeLabel: appointmentMoment.format('hh:mm A'),
    fullLabel: appointmentMoment.format('MMMM DD, YYYY hh:mm:ss A'),
    moment: appointmentMoment,
  };
};

export const formatAppointmentDateTime = (appointment) => {
  const appointmentMoment = buildAppointmentMoment(
    appointment.date || appointment.start,
    appointment.time
  );
  if (!appointmentMoment) return '';

  const timeLabel = getAppointmentTimeLabel(appointment.time);
  if (timeLabel) {
    return `${appointmentMoment.format('D MMMM')} ${timeLabel}`;
  }
  return appointmentMoment.format('D MMMM h:mm A');
};

export const isAppointmentOverdue = (reminderNoteData) => {
  const appointmentMoment = buildAppointmentMoment(
    reminderNoteData?.reminderDate,
    reminderNoteData?.time
  );
  return appointmentMoment ? appointmentMoment.isBefore(moment()) : false;
};
